@if (roLocked()) {
    <mat-icon
        class="st-ro-grid-timing-bar__ro-lock"
        fontSet="material-symbols-outlined"
        [matTooltip]="roLockedBy()">
        lock
    </mat-icon>
}
@if (onAir()) {
    @if (timingBarLocked()) {
        <mat-icon
            class="st-ro-grid-timing-bar__timing-bar-lock"
            fontSet="material-symbols-outlined"
            [matTooltip]="timingBarLockedBy()">
            lock_clock
        </mat-icon>
    } @else {
        <mat-icon
            class="st-ro-grid-timing-bar__timing-bar-timer"
            fontSet="material-symbols-outlined">
            timer
        </mat-icon>
    }
}
<div class="st-ro-grid-timing-bar__timing-over-under">
    {{ timingOverUnder() }}
</div>

@if (onAir() && roCurrentID()) {
    @if (hasHardHit()) {
        <mat-divider
            vertical
            class="st-ro-grid-timing-bar__timing-divider" />
        <div class="st-ro-grid-timing-bar__timing-hard-hit-over-under">
            {{ timingHardHitOverUnder() }}
        </div>
    }
    <mat-divider
        vertical
        class="st-ro-grid-timing-bar__timing-divider" />

    <div
        class="st-ro-grid-timing-bar__timing-segment"
        [class.st-ro-grid-timing-bar__timing-segment--red]="!isSegmentCountDown()">
        {{ languageSettings().RDSegmentTime }} {{ segmentCountDown() }}/{{ segmentCountUp() }}
    </div>
    <mat-divider
        vertical
        class="st-ro-grid-timing-bar__timing-divider" />
    <div
        class="st-ro-grid-timing-bar__timing-story"
        [class.st-ro-grid-timing-bar__timing-story--red]="!isStoryCountDown()">
        {{ languageSettings().RDStoryTime }} {{ storyCountDown() }}
    </div>
    <mat-divider
        vertical
        class="st-ro-grid-timing-bar__timing-divider" />
    <div
        class="st-ro-grid-timing-bar__timing-prog"
        [class.st-ro-grid-timing-bar__timing-prog--red]="!isProgramCountDown()">
        {{ languageSettings().RDProgramTime }} {{ programCountDown() }}
    </div>
}
@if (timingSelection()) {
    <span class="st-ro-grid-timing-bar__timing-selection">SELECTION {{ timingSelection() }}</span>
}
